import { ETicketVisibilityOptions } from '@constants';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';

type Props = {
  value?: ETicketVisibilityOptions;
  onChange: (value: string) => void;
  allowClear?: boolean;
  suffixIcon?: React.ReactNode;
};

const VISIBILITY_VALUES = [
  { label: 'PUBLIC_VISIBILITY', value: ETicketVisibilityOptions.PUBLIC },
  { label: 'PRIVATE_VISIBILITY', value: ETicketVisibilityOptions.PRIVATE }
];

export const VisibilitySelector: React.FC<Props> = ({
  value,
  onChange,
  allowClear = false,
  suffixIcon
}) => {
  const { t } = useTranslation();

  return (
    <Select
      allowClear={allowClear}
      value={value}
      onChange={onChange}
      placeholder={t('SELECT_VISIBILITY')}
      options={VISIBILITY_VALUES.map(({ label, value: val }) => ({
        label: t(label),
        value: val
      }))}
      suffixIcon={suffixIcon}
    />
  );
};
